import { membersService } from '../../transport';

export const NAMES = {
  ORGANIZATION_INVITATIONS_SUCCESS: 'MEMBER.ORGANIZATION_INVITATIONS.SUCCESS',
};

const getUserInvitationsSuccess = (invitations) => ({
  type: NAMES.ORGANIZATION_INVITATIONS_SUCCESS,
  payload: invitations,
});

export const getMemberInvitations =
  ({ memberId }) =>
  (dispatch) => {
    return membersService
      .getUserInvitations({ memberId })
      .then((response) =>
        dispatch(getUserInvitationsSuccess(response.data.payload)),
      );
  };
